<template>
  <SendAnalysis
    v-if="analysis"
    :analysis="analysis"
    :on-prepared-analysis="onPreparedAnalysis"
    @savePreparedAnalysis="savePreparedAnalysis"
    @linkedReflections="linkedReflections"
  >
    <template v-slot:button="{ activator }">
      <v-btn
        class="sendButton"
        color="primary"
        v-bind="activator.attrs"
        v-on="activator.on"
        elevation="0"
      >
        {{ $t('actions.share') }}
        <v-icon class="arrowIconSend ml-2">
          reply
        </v-icon>
      </v-btn>
    </template>
  </SendAnalysis>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { types as analysesCaptureTypes } from '../../store/analysesCapture';
import { types as analysesTypes } from '../../store/analyses';
import { types as authenticationTypes } from '../../store/authentication';
import SendAnalysis from '../dialog/SendAnalysis';

export default {
  name: 'ExtensionSendButton',
  components: {
    SendAnalysis,
  },
  props: {
    analysis: {
      type: Object,
      required: false,
      default() { return {}; },
    },
  },
  data() {
    return {
      dialogOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      onPreparedAnalysis: analysesCaptureTypes.getters.onPreparedAnalysis,
      userId: authenticationTypes.getters.userId,
    }),
  },
  methods: {
    ...mapActions({
      savePreparedAnalysisAction: analysesCaptureTypes.actions.savePreparedAnalysis,
      saveUsersAnalyses: analysesTypes.actions.saveUsersAnalyses,
    }),
    async savePreparedAnalysis() {
      console.log('savePreparedAnalysis [ExtensionSendButton]');
      await this.savePreparedAnalysisAction();
      await this.saveUsersAnalyses();
    },
    linkedReflections() {
      console.log('into linkedReflections');
    },
  },
};
</script>

<style scoped>
.arrowIconSend {
  transform: scaleX(-1);
}
.sendButton {
  font-size: 13px;
  text-transform: none;
}
</style>
